import AdminEmailLists from "./AdminEmailLists";
import AdminEmailSend from "./AdminEmailSend";
import { useState } from "react";

export default function AdminEmailMenu() {
    const [selected, setSelected] = useState(null);

    if (selected === "send") {
        return (
            <>
                <button className="btn btn-link small-link" style={{cursor: "pointer"}} onClick={() => setSelected(null)}>← Email Lists Menu</button>
                <AdminEmailSend />
            </>
        );
    } else if (selected === "lists") {
        return (
            <>
                <button className="btn btn-link small-link" style={{cursor: "pointer"}} onClick={() => setSelected(null)}>← Email Lists Menu</button>
                <AdminEmailLists />
            </>
        );
    }

    return (
        <div className="container mt-2">
            <div className="row g-3">
                <div className="col-md-6">
                    <div
                        className="card shadow-sm border-0 h-100 hover-shadow"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelected("send")}
                    >
                        <div className="card-body d-flex align-items-center">
                            <i
                                className="bi bi-envelope-paper-fill me-3 primary-color"
                                style={{ fontSize: "2rem" }}
                            ></i>
                            <div>
                                <h5 className="card-title mb-1">Send Emails</h5>
                                <p className="card-text text-muted small">Create and send a new email campaign</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div
                        className="card shadow-sm border-0 h-100 hover-shadow"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelected("lists")}
                    >
                        <div className="card-body d-flex align-items-center">
                            <i
                                className="bi bi-people-fill me-3 primary-color"
                                style={{ fontSize: "2rem" }}
                            ></i>
                            <div>
                                <h5 className="card-title mb-1">Manage Lists</h5>
                                <p className="card-text text-muted small">View and organize your email groups</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
